import { NgModule } from '@angular/core'
import { NgxMatDateFnsAdapter } from './custom-date-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core'

const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy HH:mm',
  },
  display: {
    dateInput: 'dd/MM/yyyy HH:mm',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy HH:mm',
    monthYearA11yLabel: 'MMMM yyyy',
  },
}
@NgModule({
  providers: [
    { provide: DateAdapter, useClass: NgxMatDateFnsAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
})
export class CustomDateFnsModule {}
